import React from "react";
import styled from "styled-components";
import { space, typography, layout, flexbox, border } from "styled-system";
import { rgba } from "polished";
import { rwdMobile } from "components/StyledMixin";
import { InputGroup, Input, CheckBox } from "./FormItems";

import { Col, Row } from "./Row";

const AppWrapper = styled("div")`
  background-color: #fff;
  height: 100%;
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
`;

const StyledTitle = styled("div")`
  display: flex;
  padding-right: 40px;
  padding-left: 40px;
  width: 100%;
  min-height: 90px;
  align-items: center;
  justify-content: space-between;
  background-color: ${rgba("#FFF", 75)};
  border-bottom: 1px solid #f7f7f7;
  .ant-btn.ant-btn-main:not(.ant-btn-icon-only) {
    padding-right: 20px;
  }
  .img {
    height: 60px;
    margin-left: 5px;
    margin-top: -8px;
  }
  h2 {
    margin-top: 0;
    margin-bottom: 0;
    color: ${({ theme }) => theme.Primary};
    font-size: 26px;
    line-height: 40px;
    letter-spacing: -1px;
    font-weight: 700;
    @media only screen and (max-width: 991px) {
      line-height: 30px;
    }
    @media only screen and (max-width: 479px) {
      font-size: 22px;
    }
    ${typography}
  }

  @media only screen and (max-width: 767px) {
    min-height: 68px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  @media only screen and (max-width: 991px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  ${space}
  ${layout}
  ${({ type }) => {
    if (type === "modal") {
      return `
        height: 80px;
        padding-left: 30px;
        padding-right: 30px;
        background: #f7f7f7;
        h2 {
          font-size: 22px;
          line-height: 20px;
        }
        @media only screen and (max-width: 767px ) {
          padding-left: 28px;
          height: 80px;
        }
        @media only screen and (max-width: 374px ) {
          h2 {
            width: 120px;
          }
        }
      `;
    }
  }}
  ${({ hasProgress }) => {
    if (hasProgress) {
      return `
        position: relative;
        ${rwdMobile(
          "lg",
          `
          flex-wrap: wrap;
          padding: 20px;
          height: auto;
        `
        )}
      `;
    }
  }}
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  .divider {
    width: 1px;
    height: 30px;
    margin: 0 10px;
    background-color: hsla(0, 0%, 43.1%, 0.5);
  }
`;

const AppTitle = React.forwardRef((props: any, ref) => {
  const { children, name, type, hasProgress, img, ...rests } = props;

  return (
    <StyledTitle type={type} {...rests} hasProgress={hasProgress}>
      <h2>
        {" "}
        {name}
        {/* img && (
          <img
            className="img"
            src={require(`styles/imgs/progress/${img}.png`)}
            alt="icon"
          />
        )*/}
      </h2>
      <ButtonGroup>
        <div>{children && children}</div>
      </ButtonGroup>
    </StyledTitle>
  );
});

const AppBody = styled.div`
  padding: 30px 40px 0px 40px;
  border-radius: 20px 20px 0 0;
  background-color: #fff;

  ${rwdMobile(
    "lg",
    `
    padding: 30px 20px 0px 20px;
  `
  )}

  ${rwdMobile(
    "sss",
    `
    padding-left: 15px;
    padding-right: 15px;
  `
  )}
  
  &.withoutFooter {
    border-radius: 20px;
    padding-bottom: 40px;
    ${rwdMobile(
      "sss",
      `
      padding-bottom: 30px;
    `
    )}
  }
`;

const TableHeader = styled.div`
  text-transform: uppercase;
  min-height: 50px;
  padding-right: 40px;
  padding-left: 40px;
  background-color: #f7f7f7;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.Primary};
  font-size: 13px;
  line-height: 13px;
  font-weight: 600;
  ${typography}
  ${flexbox}
  ${border}
  border-color: hsla(0,0%,43.1%,.2);
  > div {
    color: ${({ theme }) => theme.Primary};
    width: ${({ col }) => (col ? col : "20%")};
    padding-right: 10px;
    font-size: 13px;
    line-height: 13px;
    font-weight: 600;
    text-transform: uppercase;
    &:last-child {
      width: 140px;
      height: 40px;
      padding-right: 0;
    }
  }

  ${rwdMobile(
    "lg",
    `
    padding-left: 20px;
    padding-right: 20px;
    > div {
      width: 43%;
    }
  `
  )}

  ${rwdMobile(
    "xs",
    `
    > div:last-child {
      width: 90px;
    }
  `
  )}
`;

const ModalList = styled("div")`
  display: flex;
  width: 100%;
  min-height: 60px;
  padding-right: 40px;
  padding-left: 40px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => rgba(theme.Divider, 0.1)};
  transition: all 0.6s ease;
  position: relative;
  justify-content: space-between;
  color: #1e1e1e;
  &:hover {
    &:hover {
      background-color: ${({ theme }) => rgba(theme.Primary, 0.08)};
    }
  }
  @media only screen and (max-width: 991px) {
    padding-right: 20px;
    padding-left: 20px;
  }
  &.active:after {
    content: "";
    width: 16px;
    height: 12px;
    background-image: url(${require("./imgs/ico_ticker_black.png")});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

export {
  AppWrapper,
  AppTitle,
  AppBody,
  TableHeader,
  ModalList,
  Row,
  Col,
  InputGroup,
  Input,
  CheckBox,
};
